import { ProviderCard } from './ProviderCard';
import type { ProviderSearchResult } from '../types';

type ProviderResultCardsProps = {
  providers: ProviderSearchResult[];
  searchContextId?: string;
  hasClients: boolean;
  canSchedule: boolean;
  onSharePromptOpen: (provider: { id: string; name: string }) => void;
  onSchedule: (provider: {
    id: string;
    name: string;
    calendlyUrl: string | null;
    intakeFormUrl: string | null;
  }) => void;
};

export const ProviderResultCards = ({
  providers,
  searchContextId,
  hasClients,
  canSchedule,
  onSharePromptOpen,
  onSchedule,
}: ProviderResultCardsProps) => (
  <div className="space-y-4">
    {providers.map((provider) => (
      <ProviderCard
        key={provider.id}
        id={provider.id}
        searchContextId={searchContextId}
        userId={provider.user.id}
        companyName={provider.companyName}
        businessAddress={provider.businessAddress ?? null}
        hideBusinessAddress={provider.hideBusinessAddress}
        providerType={provider.providerType}
        distance={provider.distance}
        specialties={provider.specialties.map((specialty) => ({
          specialty: { id: specialty.id, name: specialty.name },
        }))}
        serviceRanges={provider.serviceRanges}
        profilePhoto={provider.user.profilePhoto}
        verified
        isInNetwork={provider.isInNetwork}
        isFavorited={provider.isFavorited}
        partnerCompany={provider.partnerCompany}
        user={provider.user}
        onSharePromptOpen={onSharePromptOpen}
        hasClients={hasClients}
        canSchedule={canSchedule}
        onSchedule={onSchedule}
        calendlyUrl={provider.calendlyUrl}
        intakeFormUrl={provider.intakeFormUrl}
        advisorBiography={provider.advisorBiography}
      />
    ))}
  </div>
);
